export type ConfigStatusObject = {
    isProgress: boolean;
    isSynced: boolean;
    pending?: any;
};